export default {
  // ------------------ 订阅管理页面开始 ----------------------------
  "subscribe_manager_title": "订阅管理",
  "subscribe_manager_subscribe_reports": "订阅报表",
  "subscribe_manager_push_title": "推送标题",
  "subscribe_manager_last_push_time": "最后一次推送时间",
  "subscribe_manager_push_result": "推送状态",
  "subscribe_manager_push_method": "推送方式",
  "subscribe_manager_push_frequency": "推送频率",
  "subscribe_manager_current_state": "当前状态",
  "subscribe_manager_handle": "操作",
  "subscribe_record_receivers": "收件人",
  "subscribe_record_send_status": "推送状态",
  "subscribe_record_last_push_time": "推送时间",
  "subscribe_record_push_history": "发送记录",

  "subscribe_manager_push_result_not": "未开始",
  "subscribe_manager_push_result_fail": "推送失败",
  "subscribe_manager_push_result_success": "推送成功",
  "subscribe_manager_push_result_part_success": "部分成功",
  "subscribe_manager_push_result_pushing": "推送中",
  "subscribe_manager_push_in_queue": "推送中", // 对应后端返回的  队列中
  "subscribe_manager_push_result_fail_info": "推送失败明细",

  "subscribe_manager_push_method_invalid": "无效",
  "subscribe_manager_push_method_email": "邮件",
  "subscribe_manager_push_method_weixin": "企业微信",

  "subscribe_manager_current_state_subscribing": "订阅中",
  "subscribe_manager_current_state_unsubscribed": "已退订",
  "subscribe_manager_current_state_finished": "已结束",
  "subscribe_manager_current_state_failure": "已失效",
  "subscribe_manager_handle_unsubscribe": "退订",
  "subscribe_manager_handle_push_again": "再次发送",
  "subscribe_manager_handle_push_report": "发送记录",
  "subscribe_manager_handle_resubscribe": "重新订阅",

  "subscribe_manager_handle_is_push_again": "是否确认再次发送报表",
  "subscribe_manager_handle_is_unsubscribe": "是否确认退订报表",
  "subscribe_manager_handle_is_delete": "删除后所有收件人将不再收到推送通知。是否确认删除{name}的订阅?",

  "subscribe_manager_search": "搜索报表名称或推送标题",

  // 推送频率文本
  "subscribe_manager_frequency_invalid": "无效",
  "subscribe_manager_frequency_push_now": "立即发送",
  "subscribe_manager_frequency_single": "单次",

  "subscribe_manager_frequency_everyday": "每天",
  "subscribe_manager_frequency_every": "每",
  "subscribe_manager_frequency_every_month": "每月",
  "subscribe_manager_frequency_day": "号",
  "subscribe_manager_success": "成功",
  "subscribe_manager_fail": "失败",
  


  // ------------------ 订阅管理页面结束 ----------------------------
  'subscribe_manager_page': '订阅管理',
  'subscribe_setting_save_success': '订阅成功！',
  'subscribe_setting_save_success1': '订阅成功！可前往',
  'subscribe_setting_save_success2': '查看报表推送情况。',
  'subscribe_setting_save_fail': '订阅失败。',
  'subscribe_setting_title': '订阅设置',
  'subscribe_setting_input_label_page': '当前订阅页面',
  'subscribe_setting_input_label_out_email': '是否发送至外部邮箱',
  'subscribe_setting_input_label_out_email_placeholder': '请手动输入收件人邮箱，用英文“;”隔开',
  'subscribe_setting_confirm_send_out_email': '报表可能包含敏感信息，是否确认发送至外部邮箱',
  'subscribe_setting_btn_sennd_modal_confirm': '确认',
  'subscribe_setting_input_page_des': '若表格宽度超屏，由于尺寸限制，仅支持订阅当前屏幕展示内容。',
  'subscribe_setting_input_label_receiver': '收件人',
  'subscribe_setting_input_placeholder_receiver': '请选择或输入收件人',
  'subscribe_setting_input_empty_receiver': '收件人不能为空',
  'subscribe_setting_input_label_title': '推送标题',
  'subscribe_setting_input_placeholder_title': '请填写标题',
  'subscribe_setting_input_empty_title': '推送标题不能为空',
  'subscribe_setting_input_label_content': '附加正文',
  'subscribe_setting_input_placeholder_content': '请填写关于推送报表的文字说明（最多允许输入1000字符）',
  'subscribe_setting_input_error_content': '内容不得大于 1000 字符',
  'subscribe_setting_input_label_ways': '推送方式',
  'subscribe_setting_input_empty_ways': '推送方式不能为空',
  'subscribe_setting_input_label_now': '立即发送',
  'subscribe_setting_input_label_one': '单次',
  'subscribe_setting_input_label_hour': '小时',
  'subscribe_setting_input_label_day': '每天',
  'subscribe_setting_input_label_week': '每周',
  'subscribe_setting_input_label_month': '每月',

  'subscribe_setting_input_label_ways_email': '邮件',
  'subscribe_setting_input_label_ways_wechat': '企业微信',
  'subscribe_setting_input_label_frequency': '推送频率',
  'subscribe_setting_input_placeholder_frequency': '请选择推送日期',
  'subscribe_setting_input_empty_frequency': '推送频率不能为空',
  'subscribe_setting_input_label_circle': '订阅周期',
  'subscribe_setting_range_time_day': '日',
  'subscribe_setting_range_time_text': '选择时间',

  'subscribe_setting_btn_save': '保存',
  'subscribe_setting_btn_preview': '预览效果',
  'subscribe_setting_btn_test': '测试发送',
  'subscribe_setting_test_title': '发送测试邮件',
  'subscribe_setting_btn_confirm': '确定',
  'subscribe_setting_btn_cancel': '取消',

  'subscribe_setting_prevew_fail_msg': '没有返回预览图片路径, 预览失败!',
  'subscribe_setting_prevew_fail': '预览失败',
  'subscribe_batch_add': '批量添加',
  'subscribe_account_type': "账号类型",
  'subscribe_username': "用户名",
  'subscribe_batch_add_placeholder': '添加多个用户请用“;”或者换行分隔',
  'subscribe_enter_valid_email': '请输入有效的邮箱地址',
  'subscribe_email_not_exist': '邮箱地址不存在',
  'subscribe_username_not_exist': '用户名不存在',
  'subscribe_username_invalid': '用户名无效',
};
